import { render, staticRenderFns } from "./Drivers.vue?vue&type=template&id=4c7fb2fe&scoped=true&"
import script from "./Drivers.vue?vue&type=script&lang=js&"
export * from "./Drivers.vue?vue&type=script&lang=js&"
import style0 from "./Drivers.vue?vue&type=style&index=0&id=4c7fb2fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7fb2fe",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})


/* hot reload */
if (module.hot) {
  var api = require("/working_dir/management-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c7fb2fe')) {
      api.createRecord('4c7fb2fe', component.options)
    } else {
      api.reload('4c7fb2fe', component.options)
    }
    module.hot.accept("./Drivers.vue?vue&type=template&id=4c7fb2fe&scoped=true&", function () {
      api.rerender('4c7fb2fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Drivers.vue"
export default component.exports